import React from "react";
import PropTypes from "prop-types";
import {withStyles} from "@mui/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Paper from "@mui/material/Paper";
import Tooltip from "@mui/material/Tooltip";
import download from '../images/download-doc.svg';
import "react-daterange-picker/dist/css/react-calendar.css";
import Avatar from "@mui/material/Avatar";
import spinner from '../../assign-prescriptions/images/spinner.gif';
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import SwipeableViews from 'react-swipeable-views';
import AppBar from '@mui/material/AppBar';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from "@mui/material/Typography";
import Dashboard from '../temparature_monitoring/Dashboard';
import { IconButton, Grid, CircularProgress } from "@mui/material";
import moment from 'moment-timezone';
import {generateCSV} from "../../../utils/GenerateCSV";
import {withTranslation} from "react-i18next";
import {getDefaultDateRange, getDateRangeByPreset, formatFromDateForAPI, formatToDateForAPI} from "../../../utils/datetime.utils";
//import getTypeByLang from '../../common/typeByLang';
import enLocale from "date-fns/locale/en-US";
import frLocale from "date-fns/locale/fr";
import ConnectionType from "../../common/connection-type";
import ILocalAGGrid, {
  getDefaultColDef,
  createServerSideDatasource,
  withDateColumnFilter,
  applyReportFilterModel,
  attachReportServerSideDatasource,
  PHARMACY_REPORT_SORT_MAP,
  withClickableCell,
  resolveGridRow,
} from "../../grid/iLocalAGGrid";
import { ReportToolbar } from "../ReportPageLayout";

function getReportTimezone() {
  const stored = sessionStorage.getItem('timeZone');
  if (stored) return stored.substring(stored.lastIndexOf(' ') + 1);
  return Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
}

function TabContainer({ children, dir, classes }) {
  return (
    <Typography component="div" dir={dir} style={{ padding: 8 * 3 }}>
      {children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
  dir: PropTypes.string.isRequired,
};

class EnhancedTableHead extends React.Component {
  createSortHandler = (property, field) => event => {
    this.props.onRequestSort(event, property, field);
  };

  render() {
    const {order, orderBy, sortId, t} = this.props;
    const rows = [
      { id: "firstname", numeric: false, disablePadding: false, label: t("Report.Receivable.FirstName"), padding: '10px', field: 'first_name' },
      { id: "lastname", numeric: false, disablePadding: false, label: t("Report.Receivable.LastName"), padding: '10px', field: 'last_name' },
      { id: "store", numeric: false, disablePadding: false, label: t("Report.Receivable.Account"), padding: '10px', field: 'name' },
      { id: "box", numeric: false, disablePadding: false, label: t("Report.Receivable.Location"), padding: '10px', field: 'name' },
      { id: "amount_due", numeric: false, disablePadding: false, label: t("Report.Receivable.AmountDue"), padding: '10px', field: 'amount_due' },
      { id: "paid_amount", numeric: false, disablePadding: false, label: t("Report.Receivable.Paid"), padding: '10px', field: 'paid_amount' },
      { id: "balance_due", numeric: false, disablePadding: false, label: t("Report.Receivable.BalanceDue"), padding: '10px', field: 'balance_due' },
      { id: "entryType", numeric: false, disablePadding: false, label: t("Report.Receivable.EntryType"), padding: '10px', field: 'price' },
      { id: "payDate", numeric: false, disablePadding: false, label: t("Report.Receivable.PaymentDate"), padding: '10px', field: 'price' },
      { id: "payType", numeric: false, disablePadding: false, label: t("Report.Receivable.PaymentType"), padding: '10px', field: 'price' },
      { id: "rxno", numeric: false, disablePadding: false, label: t("Report.Receivable.RxHash"), padding: '10px', field: 'rx_no' },
      { id: "prescriptionnumber", numeric: false, disablePadding: false, label: t("Report.Receivable.PrescriptionID"), padding: '10px', field: 'prescriptionnumber' },
      { id: "pucode", numeric: false, disablePadding: false, label: t("Report.Receivable.PUCode"), padding: '10px', field: 'pucode' },
      { id: "stockeddate", numeric: false, disablePadding: false, label: t("Report.Receivable.StockDate"), padding: '10px', field: 'stock_code' },
      { id: "pickupdate", numeric: false, disablePadding: false, label: t("Report.Receivable.PickupDate"), padding: '10px', field: 'pickup_date' }
    ];

    return (
      <TableHead>
        <TableRow>
          {rows.map(row => {
            return (
              <TableCell
                key={row.id}
                numeric={row.numeric}
                padding={row.disablePadding ? "none" : "default"}
                sortDirection={orderBy === row.id ? order : false}
                style={{ padding: row.padding, color: 'rgba(0, 0, 0, 0.54)' }}>
                {[
                  "deliverytype",
                  "fillid",
                  "prescriptionnumber",
                  "OrderId",
                  "PrescriptionTxnId",
                  "ndccode",
                  "qty",
                  "price",
                ].includes(row.id) ? (
                  <TableSortLabel style={{ cursor: "text" }}>{row.label}</TableSortLabel>
                ) : (
                  <Tooltip
                    title={t("Global.Label.Filter.Sort")}
                    placement={row.numeric ? "bottom-end" : "bottom-start"}
                    enterDelay={300}>
                    <TableSortLabel
                      active={orderBy === row.field && sortId === row.id}
                      direction={order}
                      onClick={this.createSortHandler(row.id, row.field)}>
                      {row.label}
                    </TableSortLabel>
                  </Tooltip>
                )}
              </TableCell>
            );
          }, this)}
        </TableRow>
      </TableHead>
    );
  }
}

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  sortId: PropTypes.string.isRequired
};
EnhancedTableHead = withTranslation()(EnhancedTableHead);

const styles = theme => ({
  // root: {
  //   width: "100%",
  //   // marginTop: theme.spacing.unit * 3
  // },
  table: {
    minWidth: 1020
  },
  tableWrapper: {
    overflowX: "auto"
    // paddingTop:'10%'
  },
  dob: {
    paddingTop: '25px',
  },
  headerdiv: {
    paddingLeft: '15%',
    paddingTop: '10'
  },
  padding10px: {
    padding: '10px'
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
    maxWidth: 390,
  },
  logoWrapper:
  {
    position: 'absolute',
    width: '89%',
    height: '70%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: 'rgba(255,255,255,0.5)',
    zIndex: '7869'
  },
  spinner: {
    position: 'absolute',
    background: 'rgba(255,255,255,.4)',
    width: '100%',
    height: '100%',
    zIndex: '9999',
    top: 0,
    left: 0,
  },
  spinnerImage: {
    top: 'calc(50% - 32.5px)',
    left: 'calc(50% - 65px)',
    position: 'absolute',
    width: '130px',
    userSelect: 'none'
  },
  hidden: {
    display: 'none'
  },
  rowheight: {
    height: '35px'
  },
  primaryButton: {
    background: '#6cca98',
    color: '#fff',
    '&:hover': {
      background: '#6cca98',
      color: '#fff',
    },
    '&:disabled': {
      color: 'rgba(0, 0, 0, 0.38)',
      cursor: 'not-allowed',
      background: '#E4E5E8'
    },
  }
});

const __reportDefaultDates = getDefaultDateRange();

let TransactionFilterObj = {
  store_ids: [],
  box_ids: [],
  searchtext: '',
  fromdate: formatFromDateForAPI(__reportDefaultDates.fromDate),
  todate: formatToDateForAPI(__reportDefaultDates.toDate),
  pageNo: 0,
  pageSize: 10,
  sortOrder: 'desc',
  sortColumn: 'pickup_date',
  tableName: '',
  group_id: null
}

const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
const findOffset = moment().tz(timeZone).utcOffset();
const defaultZone = `(UTC ${findOffset}) ${timeZone}`;
class EnhancedTable extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      order: "desc",
      dob: '',
      orderBy: "created_on",
      page: 0,
      rowsPerPage: 10,
      searchtext: '',
      store_id: [],
      box_id: [],
      fromdate: null,
      todate: null,
      dateRangePreset: 'last7days',
      isOpen: false,
      stores: [],
      boxes: [],
      boxvalues: [],
      accountValues: [],
      nstores: [],
      nboxes: [],
      chipstores: [],
      chipboxes: [],
      loader: false,
      selectedObject: null,
      isDataEmpty: true,
      selectedTab: 0,
      tempThresholds: [],
      totalRecords: 0,
      isButtonDisabled: false,
      locale: localStorage.getItem('i18nextLng') === 'en' ? enLocale : frLocale,
      retryLoader: false,
      retryMessg: [],
      queryId: "",
      groups: [],
    };
    this.handleStoreChange = this.handleStoreChange.bind(this);
    this.debouceTimeout = null;
  }

  refreshGrid = () => {
    if (!this.gridApi) return;
    if (typeof this.gridApi.refreshServerSideStore === "function") {
      this.gridApi.refreshServerSideStore({ purge: true });
    } else if (typeof this.gridApi.refreshServerSide === "function") {
      this.gridApi.refreshServerSide({ purge: true });
    }
  };

  onPaginationChanged = (params) => {
    if (!params.api) return;
    const newPageSize = params.api.paginationGetPageSize();
    const body = this._agFilterBody;
    if (body && newPageSize && body.pageSize !== newPageSize) {
      body.pageSize = newPageSize;
    }
  };

  componentDidMount() {
    TransactionFilterObj.group_id = sessionStorage.getItem("groupID")
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + "accounts", {
      method: 'GET',
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
        'Content-Type': 'application/json'
      }
    })
      .then(response => response.json())
      .then(accounts => {
        const {t} = this.props;
        let All = [{ id: "-1", name: t("Global.Label.DropDown.All") }]
        const storelist = accounts.map(account => {
          return { id: account.id, name: account.name };
        });

        const accountValues = All.concat(storelist);
        this.setState({ accountValues, parent_account_id: accountValues[0].id });
        this.BindBoxesbyStoreId(storelist.map(x => x.id));
        this.setState({ loader: false });
      });
    // Set default date range (T-30 days to today)
    const defaultDates = getDefaultDateRange();
    this.setState({
      fromdate: defaultDates.fromDate,
      todate: defaultDates.toDate,
      dateRangePreset: 'last7days'
    });

    Object.assign(TransactionFilterObj, {
      store_ids: [],
      box_ids: [],
      searchtext: '',
      fromdate: formatFromDateForAPI(defaultDates.fromDate),
      todate: formatToDateForAPI(defaultDates.toDate),
      pageNo: 0,
      pageSize: 10,
      sortOrder: 'desc',
      sortColumn: 'pickup_date',
      tableName: ''});
    this.fetchSuggestions()
    this.setState({ loader: false });
  }

  convertToTimeZone = (requestDate) => {
    const currentUserLang = localStorage.getItem('i18nextLng');
    let zone;
    zone = sessionStorage.getItem('timeZone');
    const date = moment(new Date(requestDate));
    if (['null', null, 'undefined', undefined].includes(zone)) {
      zone = defaultZone;
    }
    return currentUserLang === 'en' ? date.tz(zone.substring(zone.lastIndexOf(' ') + 1)).format('MM/DD/YYYY hh:mm:ss A') : date.tz(zone.substring(zone.lastIndexOf(' ') + 1)).format('DD/MM/YYYY hh:mm:ss A');
  }

  exportCSV() {
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + 'CSV/iPayReceivableReport', {
      method: 'POST',
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ ...TransactionFilterObj, timezone: getReportTimezone() })
    })
      .then(response => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then((csvData) => {
        this.setState({ loader: false });
        let headers = [
          "FirstName,LastName,Account,Location,Amount,Paid,Balance Due,Entry Type,Payment Date,Payment Type,Rx Number,Prescription ID,PickUpCode,Stock Date,Pick Up Date",
        ];
        let result =
          csvData && csvData.Results && csvData.Results.length > 0
            ? csvData.Results
            : [];
        if (result !== undefined && result !== "undefined") {
          if (result && result.length > 0) {
            let prepareCSvData = result.reduce((obj, block) => {
              const {
                firstname,
                lastname,
                store,
                box,
                price,
                amount_due,
                paid_amount,
                balance_due,
                rxno,
                prescriptionnumber,
                pucode,
                stockeddate,
                pickupdate,
                entry_type,
                payment_date,
                payment_type,
              } = block;
              obj.push(
                [
                  firstname ? firstname : "",
                  lastname ? lastname : "",
                  store ? store.replaceAll(",", " ").trim() : "",
                  box ? box.replaceAll(",", " ").trim() : "",
                  amount_due != null ? "$" + parseFloat(amount_due).toFixed(2) : (price ? "$" + parseFloat(price).toFixed(2) : "$0.00"),
                  paid_amount != null ? "$" + parseFloat(paid_amount).toFixed(2) : "$0.00",
                  balance_due != null ? "$" + parseFloat(balance_due).toFixed(2) : (price ? "$" + parseFloat(price).toFixed(2) : "$0.00"),
                  entry_type ? entry_type : "",
                  payment_date ? this.convertToTimeZone(payment_date) : "",
                  payment_type ? payment_type : "",
                  rxno ? rxno : "",
                  prescriptionnumber ? prescriptionnumber : "",
                  pucode ? pucode : "",
                  stockeddate ? this.convertToTimeZone(stockeddate) : "",
                  pickupdate ? this.convertToTimeZone(pickupdate) : "",
                ].join(",")
              );
              return obj;
            }, []);

            let populateCSVData = [...headers, ...prepareCSvData].join("\n");
            generateCSV({
              data: populateCSVData,
              fileName: "IPayReceivablesReport.csv",
              fileType: "text/csv",
            });
          }
        }
      });
  };

  gettingOnSortTableName = (field) => {
    let tablename = '';
    if (['firstname', 'lastname', 'patientNotes'].includes(field)) {
      tablename = 'customers';
    }
    if (['box'].includes(field)) {
      tablename = 'boxes';
    }
    if (['rxno', 'drugname'].includes(field)) {
      tablename = 'prescription_detail';
    }
    if (['stock_code', 'pucode', 'stockeddate', 'pickupdate', 'binid'].includes(field)) {
      tablename = 'prescriptions_master';
    }
    if (['store'].includes(field)) {
      tablename = 'accounts';
    }
    return tablename;
  }

  handleRequestSort = (event, property, field) => {
    const orderBy = property;
    let order = "desc";
    if (this.state.orderBy === orderBy) {
      order = this.state.order === "asc" ? "desc" : "asc";
    } else if (this.state.order === order) {
      order = "asc";
    } else {
      order = "desc";
    }
    this.setState({ order, orderBy, sortId: property });
    TransactionFilterObj.sortOrder = order;
    TransactionFilterObj.sortColumn = field;
    TransactionFilterObj.tableName = this.gettingOnSortTableName(orderBy);

    if (this.state.data && this.state.data.length > 0) {
      this.BindGrid();
    }
  };

  handleChangePage = (event, page) => {
    event && event.preventDefault();

    TransactionFilterObj.pageNo = page;
    if (this.state.data && this.state.data.length > 0) {
      this.BindGrid();
    }
  };

  handleChangeRowsPerPage = event => {

    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.pageSize = event.target.value;
    if (this.state.data && this.state.data.length > 0) {
      this.BindGrid();
    }
  };

  //Bind Boxes by store id
  onGridReady = (params) => {
    this.gridApi = params.api;
    this._agFilterBody = TransactionFilterObj;
    const datasource = createServerSideDatasource({
      sortMap: PHARMACY_REPORT_SORT_MAP,
      filterBody: TransactionFilterObj,
      applyFilterModel: (body, filterModel) => {
        applyReportFilterModel(body, filterModel, { dateColIds: ['payDate'] });
      },
      pageZeroBased: true,
      getPageSize: () => TransactionFilterObj.pageSize || 10,
      fetchPage: (body) =>
        fetch(process.env.REACT_APP_BASEURL + 'getIpayReceivables', {
          method: "post",
          withCredentials: true,
          headers: {
            Authorization:
              "Bearer " +
              JSON.parse(sessionStorage.getItem("user")).signInUserSession
                .idToken.jwtToken,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(body),
        })
          .then((r) => r.json())
          .then((data) => {
            if (data && data.results) return data;
            if (data && data.data && data.data.results) {
              return { results: data.data.results, total: data.data.total };
            }
            if (Array.isArray(data)) return { results: data, total: data.length };
            return {
              results: (data && data.rows) || [],
              total: (data && data.total) || 0,
            };
          }),
      onSuccess: (results, total) => {
        this.setState({
          data: results,
          totalRecords: total,
          loader: false,
          isDataEmpty: !results || results.length === 0,
        });
      },
      onError: () => this.setState({ loader: false }),
    });
    attachReportServerSideDatasource(params, datasource, TransactionFilterObj, 'payDate');
  };

  BindBoxesbyStoreId(store_ids) {
    if (store_ids.length > 0) {
      this.setState({ loader: true });
      let BoxesObj = {
        store_ids: store_ids
      }
      fetch(process.env.REACT_APP_BASEURL + 'getBoxesByStoreIds', {
        method: 'post',
        withCredentials: true,
        headers: {
          'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(BoxesObj)
      })
        .then(response => {
          try {
            return response.json();
          } catch (error) {
            return null;
          }
        })
        .then(data => {
          const {t} = this.props;
          let All = [{ id: "-1", name: t("Global.Label.DropDown.All") }]
          const boxlist = data.map(account => {
            return { id: account.id, name: account.name };
          });
          const boxvalues = All.concat(boxlist);
          this.setState({ chipboxes: [] });
          this.setState({ nboxes: [] });
          this.setState({ boxvalues: boxvalues });
          this.setState({ loader: false });
        });
    }
  }

  handleStoreChange = event => {
    const storeid = event.target.value;
    const storeids = [];
    let processed = [];
    let chipprocessed = [];
    const AllprocessedIndex = storeid.findIndex(x => x.id === '-1');

    if (AllprocessedIndex > -1) {
      chipprocessed = [this.state.accountValues[0]];
      for (let i = 0; i < this.state.accountValues.length; i++) {
        processed.push(this.state.accountValues[i]);
      }
    }
    else if (storeid.length === 0) {
      chipprocessed = [];
      processed = [];
    }
    else if (storeid.length > 0) {
      for (let i = 0; i < event.target.value.length; i++) {
        const element = event.target.value[i];
        if (element.id !== '-1') {
          chipprocessed.push(element);
          processed.push(element);
        }
      }
    }
    this.setState({ chipstores: chipprocessed });
    this.setState({ nstores: processed });

    if (processed.length > 0) {
      for (let i = 0; i < processed.length; i++) {
        if (processed[i].id !== '-1') {
          storeids.push(processed[i].id)
        }
      }
    }
    this.setState({ store_id: storeids });
    TransactionFilterObj.store_ids = storeids;
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'pickup_date';
    TransactionFilterObj.tableName = '';
    this.BindBoxesbyStoreId(storeids);
    this.BindGrid();
  };

  handleDeleteStoreChip = (chipToDelete) => (event) => {
    if (event && event.stopPropagation) {
      event.stopPropagation();
    }
    if (chipToDelete.id === '-1') {
      this.setState({ chipstores: [], nstores: [], store_id: [] });
      TransactionFilterObj.store_ids = [];
      TransactionFilterObj.pageNo = 0;
      this.BindBoxesbyStoreId([]);
      this.BindGrid();
      return;
    }
    const updatedStores = this.state.chipstores.filter(chip => chip.id !== chipToDelete.id);
    const updatedNStores = this.state.nstores.filter(store => store.id !== chipToDelete.id);
    this.setState({ chipstores: updatedStores, nstores: updatedNStores });
    const storeids = updatedNStores.filter(s => s.id !== '-1').map(s => s.id);
    this.setState({ store_id: storeids });
    TransactionFilterObj.store_ids = storeids;
    TransactionFilterObj.pageNo = 0;
    this.BindBoxesbyStoreId(storeids);
    this.BindGrid();
  };

  handleClearAllStores = (event) => {
    if (event && event.stopPropagation) {
      event.stopPropagation();
    }
    this.setState({ chipstores: [], nstores: [], store_id: [] });
    TransactionFilterObj.store_ids = [];
    TransactionFilterObj.pageNo = 0;
    this.BindBoxesbyStoreId([]);
    this.BindGrid();
  };

  //Search Text Box change event
  onSearchChange = (event) => {
    this.debouceTimeout && clearInterval(this.debouceTimeout);
    const searchString = event.target.value;
    this.setState({ searchtext: searchString && searchString });
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'pickup_date';
    TransactionFilterObj.tableName = '';
    TransactionFilterObj.searchtext = searchString;
    this.debouceTimeout = setTimeout(() => {
      this.BindGrid();
    }, 1000)
  }
  onFromDateSelect = date => {
    const dateObj = date ? moment(date) : null;
    this.setState({ fromdate: dateObj, dateRangePreset: '' });
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'pickup_date';
    TransactionFilterObj.tableName = '';
    TransactionFilterObj.fromdate = formatFromDateForAPI(dateObj);
    this.BindGrid();
  };
  onToDateSelect = date => {
    const dateObj = date ? moment(date) : null;
    this.setState({ todate: dateObj, dateRangePreset: '' });
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'pickup_date';
    TransactionFilterObj.tableName = '';
    TransactionFilterObj.todate = formatToDateForAPI(dateObj);
    this.BindGrid();
  };
  handleBlurfrom = (value, date) => {
    const dateObj = date ? moment(date) : null;
    this.setState({
      fromdate: dateObj,
      dateRangePreset: ''
    });
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'pickup_date';
    TransactionFilterObj.tableName = ''
    TransactionFilterObj.fromdate = formatFromDateForAPI(dateObj);
    this.BindGrid();
  }
  handleBlurtodate = (value, date) => {
    const dateObj = date ? moment(date) : null;
    this.setState({
      todate: dateObj,
      dateRangePreset: ''
    });
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'pickup_date';
    TransactionFilterObj.tableName = ''
    TransactionFilterObj.todate = formatToDateForAPI(dateObj);
    this.BindGrid();
  }

  handleDateRangePresetChange = (event) => {
    const preset = event.target.value;
    if (!preset) return;

    const dateRange = getDateRangeByPreset(preset);
    this.setState({
      fromdate: dateRange.fromDate,
      todate: dateRange.toDate,
      dateRangePreset: preset
    });

    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'pickup_date';
    TransactionFilterObj.tableName = '';
    TransactionFilterObj.fromdate = formatFromDateForAPI(dateRange.fromDate);
    TransactionFilterObj.todate = formatToDateForAPI(dateRange.toDate);
    this.BindGrid();
  };

  BindGrid = () => {
    if (this.gridApi) {
      this.refreshGrid();
      return;
    }
    // SSRM datasource is attached in onGridReady; avoid a parallel
    // legacy fetch/setState race that leaves the grid on Please Wait...
    this.setState({ loader: false });
  };
  handlePUcodeClick = (event, pmid) => {
    if (event && typeof event.preventDefault === 'function') event.preventDefault();
    this.setState({ tempThresholds: [] });
    const selectedObject = resolveGridRow(pmid, this.state.data, (x, id) => x.pmid === id);
    if (!selectedObject) return;
    this.setState({ detailDialogOpen: true, selectedObject: selectedObject })
    this.setState({
      boxAddress: (selectedObject.address_line_1 + ' '
        + selectedObject.address_line_2 + ','
        + selectedObject.city + ', '
        + selectedObject.state + ' '
        + selectedObject.zip + '')
    })
  }
  handlePUcodeClose = (event) => {
    event.preventDefault();
    this.setState({ detailDialogOpen: false, selectedObject: null, selectedTab: 0, retryMessg: "" })
  }
  handlePrintReceipt = () => {
    this.setState({ detailDialogOpen: false, printDialogOpen: true })
    setTimeout(() => {
      window.print();
      this.setState({ printDialogOpen: false, detailDialogOpen: false, selectedObject: null })
    }, 100);
  }

  handleTabChange = (event, index) => {
    this.setState({ selectedTab: index });
  };

  handleChangeIndex(index) {
    this.setState({ selectedTab: index });
  };

  handleTemperatureHistory = () => {
    this.getTemperatureHistoryByOrderId();
  }

  getTemperatureHistoryByOrderId = () => {
    let temperatureHistory = {
      startdate: this.state.selectedObject.stockeddate,
      enddate: this.state.selectedObject.pickupdate,
      orderId: this.state.selectedObject.pmid
    }
    fetch(process.env.REACT_APP_BASEURL + 'temperature/history/by/expansion', {
      method: 'post',
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(temperatureHistory)
    }).then(response => {
      try {
        return response.json();
      } catch (error) {
        return null;
      }
    }).then(tempData => {
      if (tempData && tempData.length > 0) {
        this.setState({ tempThresholds: tempData });
      }
    });
  }

  exportTemperatureHistory = () => {
    let csvRow = [];
    let A = [['', 'Temperature', 'Date']];
    let re = this.state !== null ? this.state.tempThresholds : [];
    if (re !== undefined) {
      if (re.length > 0) {
        for (let item = 0; item < re.length; item++) {
          A.push([re[item].temperature,
          re[item].date ? this.convertToTimeZone(re[item].date) : '',
          ]);
        }
        for (let i = 0; i < A.length; ++i) {
          csvRow.push(A[i].join(","));
        }
        let csvString = csvRow.join("%0A");
        let a = document.createElement("a");
        a.href = 'data:attachment/csv.' + csvString;
        a.target = "_Blank";
        a.download = `TemperatureHistory_${new Date()}.csv`;
        document.body.appendChild(a);
        a.click();
      }
    }
  }

  getColor = (isOfflinePickup) => {
    if (isOfflinePickup === true)
      return { bgColor: '#00a7e1', fontColor: '#fff' };
    else
      return { bgColor: '#fff', fontColor: 'rgba(0, 0, 0, 0.87)' };
  };

  getLinkColor = (isOfflinePickup) => {
    if (isOfflinePickup === true)
      return '#fff';
    else
      return '#385cad';
  };

  handleRetry = () => {
    console.log(this.state.selectedObject, "obj...")
    this.setState({ retryLoader: true })
    const retryObj = {
      customer_id: this.state.selectedObject && this.state.selectedObject.customers_id,
      order_id: this.state.selectedObject && this.state.selectedObject.pmid
    }
    fetch(process.env.REACT_APP_BASEURL + 'qs1/rx-complete', {
      method: 'post',
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(retryObj)
    }).then(response => {
      try {
        return response.json();
      } catch (error) {
        return error;
      }
    }).then((res) => {
      let resData = res.responseData ? res.responseData : res
      const _message = res.responseData ? `statusCode: ${resData[0].error_code}\nmessage: ${resData[0].error_message}` : `statusCode: ${resData.statusCode}\nmessage: ${resData.message}`
      this.setState({ retryLoader: false, retryMessg: _message });
    }).catch((err) => {
      this.setState({ retryLoader: false, retryMessg: err })
    })
  }

  handleMCKESSONERXRetry = () => {
    this.setState({ retryLoader: true })
    const retryObj = {
      customer_id: this.state.selectedObject && this.state.selectedObject.customers_id,
      order_id: this.state.selectedObject && this.state.selectedObject.pmid
    }
    fetch(process.env.REACT_APP_BASEURL + 'mc-kesson/rx-complete', {
      method: 'post',
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(retryObj)
    }).then(response => {
      try {
        return response.json();
      } catch (error) {
        return error;
      }
    }).then((res) => {
      const _message = `statusCode: ${res.error_code}\nmessage: ${res.error_message}`
      this.setState({ retryLoader: false, retryMessg: _message });
    }).catch((err) => {
      this.setState({ retryLoader: false, retryMessg: err })
    })
  }

  handleEpicRetry = () => {
    this.setState({ retryLoader: true })
    const retryObj = {
      customer_id: this.state.selectedObject && this.state.selectedObject.customers_id,
      order_id: this.state.selectedObject && this.state.selectedObject.pmid,
      account_id: this.state.selectedObject && this.state.selectedObject.account_id,
    }
    fetch(process.env.REACT_APP_BASEURL + 'phi-retry/epic/rx-complete', {
      method: 'post',
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(retryObj)
    }).then(response => {
      try {
        return response.json();
      } catch (error) {
        return error;
      }
    }).then((res) => {
      this.setState({ retryLoader: false, retryMessg: JSON.stringify(res, null, 2) });
    }).catch((err) => {
      this.setState({ retryLoader: false, retryMessg: err })
    })
  }

  handleEpicWithMTLSRetry = () => {
    this.setState({ retryLoader: true })
    const retryObj = {
      customer_id: this.state.selectedObject && this.state.selectedObject.customers_id,
      order_id: this.state.selectedObject && this.state.selectedObject.pmid,
      account_id: this.state.selectedObject && this.state.selectedObject.account_id,
    }
    fetch(process.env.REACT_APP_BASEURL + 'phi-retry/epic-mtls/rx-complete', {
      method: 'post',
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(retryObj)
    }).then(response => {
      try {
        return response.json();
      } catch (error) {
        return error;
      }
    }).then((res) => {
      this.setState({ retryLoader: false, retryMessg: JSON.stringify(res, null, 2) });
    }).catch((err) => {
      this.setState({ retryLoader: false, retryMessg: err })
    })
  }

  handlePioneerRxRetry = () => {
    this.setState({ retryLoader: true })
    const retryObj = {
      customer_id:
        this.state.selectedObject && this.state.selectedObject.customers_id,
      order_id: this.state.selectedObject && this.state.selectedObject.pmid,
      relationship:
        this.state.selectedObject && this.state.selectedObject.prelationship,
      drivers_license_no:
        this.state.selectedObject &&
        this.state.selectedObject.pdrivers_license_no,
      selectedstatecode:
        this.state.selectedObject &&
        this.state.selectedObjectselectedstatecode,
      first_name:
        this.state.selectedObject && this.state.selectedObject.pfirst_name,
      middle_name: null,
      last_name:
        this.state.selectedObject && this.state.selectedObject.plast_name,
    };
    fetch(process.env.REACT_APP_BASEURL + 'phi-retry/pioneer/rx-complete', {
      method: 'post',
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(retryObj)
    }).then(response => {
      try {
        return response.json();
      } catch (error) {
        return error;
      }
    }).then((res) => {
      this.setState({ retryLoader: false, retryMessg: JSON.stringify(res, null, 2) });
    }).catch((err) => {
      this.setState({ retryLoader: false, retryMessg: err })
    })
  }

  handleLibertyRetry = () => {
    this.setState({ retryLoader: true })
    const retryObj = {
      customer_id: this.state.selectedObject && this.state.selectedObject.customers_id,
      order_id: this.state.selectedObject && this.state.selectedObject.pmid,
      account_id: this.state.selectedObject && this.state.selectedObject.account_id,
    }
    fetch(process.env.REACT_APP_BASEURL + 'phi-retry/liberty/rx-complete', {
      method: 'post',
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(retryObj)
    }).then(response => {
      try {
        return response.json();
      } catch (error) {
        return error;
      }
    }).then((res) => {
      this.setState({ retryLoader: false, retryMessg: JSON.stringify(res, null, 2) });
    }).catch((err) => {
      this.setState({ retryLoader: false, retryMessg: err })
    })
  }

  handleDRXRetry = () => {
    this.setState({ retryLoader: true })
    const retryObj = {
      pucode: this.state.selectedObject && this.state.selectedObject.pucode,
      accountId: this.state.selectedObject && this.state.selectedObject.account_id
    }
    fetch(process.env.REACT_APP_BASEURL + 'drx/prescription/update', {
      method: 'post',
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(retryObj)
    }).then(response => {
      try {
        return response.json();
      } catch (error) {
        return error;
      }
    }).then((res) => {
      const _message = res && res.data;
      this.setState({ retryLoader: false, retryMessg: JSON.stringify(_message, null, 2) });
    }).catch((err) => {
      this.setState({ retryLoader: false, retryMessg: err })
    })
  }

  handleMScriptsRetry = () => {
    this.setState({ retryLoader: true })
    let orderIds = [];
    orderIds.push(this.state.selectedObject && this.state.selectedObject.order_id);
    const retryObj = {
      order_ids: orderIds,
      delivery_status: 'PICKED_UP',
      patient_signature: this.state.selectedObject && this.state.selectedObject.psignature_url,
      delivery_code: this.state.selectedObject && this.state.selectedObject.pucode
    }
    console.log(JSON.stringify(retryObj, null, 2));
    fetch(process.env.REACT_APP_BASEURL + 'update/order-status', {
      method: 'put',
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(retryObj)
    }).then(response => {
      try {
        return response.json();
      } catch (error) {
        return error;
      }
    }).then((res) => {
      this.setState({ retryLoader: false, retryMessg: JSON.stringify(res, null, 2) });
    }).catch((err) => {
      this.setState({ retryLoader: false, retryMessg: err })
    })
  }

  handleInputChange = (event) => {
    this.setState({ queryId: event.target.value });
    TransactionFilterObj.group_id = event.target.value
    this.BindGrid();

  };

  fetchSuggestions = async () => {
    try {
      const result = fetch(`${process.env.REACT_APP_BASEURL}groups/search`, {
        method: "GET",
        withCredentials: true,
        headers: {
          Authorization:
            "Bearer " +
            JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
              .jwtToken,
          "Content-Type": "application/json",
        },
      }
      );
      result
        .then((result) => {
          result.json().then((resLocation) => {
            this.setState({ groups: resLocation && resLocation.data })
          })
        })
    } catch (error) {
      console.error("Error fetching groups:", error);
    }
  };

  render() {
    const {classes, theme, t} = this.props;

    return (
      <Paper>
        {
          this.state.loader ?
            <div className={classes.spinner}>
              <img className={classes.spinnerImage} src={spinner} alt="loading" />
            </div> :
            null
        }
        <div id="react-no-print">
          <Dialog
            open={this.state.detailDialogOpen || false}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            PaperProps={{
              style: { borderRadius: '5px', maxWidth: '100%', width: '90%' }
            }}
          >
            <AppBar position="static" color="default">
              <Tabs
                value={this.state.selectedTab}
                onChange={this.handleTabChange}
                indicatorColor="primary"
                textColor="primary"
                variant={null}>
                <Tab label={t("Report.Receivable.PatientDetail.PatientDetailsTitle")} />
                <Tab label={t("Report.Receivable.Temperature.TemperatureHistoryTitle")} onClick={this.handleTemperatureHistory} />
              </Tabs>
            </AppBar>
            <SwipeableViews
              axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
              index={this.state.selectedTab}
              onChangeIndex={() => this.handleChangeIndex}>
              <TabContainer dir={theme.direction}>
                <DialogTitle id="alert-dialog-title">{t("Report.Receivable.PatientDetail.PickupByText")}</DialogTitle>
                <DialogContent>
                  <Table aria-labelledby="tableTitle">
                    <TableHead>
                      <TableRow>
                        <TableCell className={classes.padding10px} style={{ color: 'rgba(0, 0, 0, 0.54)' }}>{t("Report.Receivable.PatientDetail.FirstName")}</TableCell>
                        <TableCell className={classes.padding10px} style={{ color: 'rgba(0, 0, 0, 0.54)' }}>{t("Report.Receivable.PatientDetail.LastName")}</TableCell>
                        <TableCell className={classes.padding10px} style={{ color: 'rgba(0, 0, 0, 0.54)' }}>{t("Report.Receivable.PatientDetail.ContactlessPickup")}</TableCell>
                        <TableCell className={classes.padding10px} style={{ color: 'rgba(0, 0, 0, 0.54)' }}>{t("Report.Receivable.PatientDetail.IDNo")}</TableCell>
                        <TableCell className={classes.padding10px} style={{ color: 'rgba(0, 0, 0, 0.54)' }}>{t("Report.Receivable.PatientDetail.Signature")}</TableCell>
                        <TableCell className={classes.padding10px} style={{ color: 'rgba(0, 0, 0, 0.54)' }}>{t("Report.Receivable.PatientDetail.Picture")}</TableCell>
                        <TableCell className={classes.padding10px} style={{ color: 'rgba(0, 0, 0, 0.54)' }}>{t("Report.Receivable.PatientDetail.Relationship")}</TableCell>
                        <TableCell className={classes.padding10px} style={{ color: 'rgba(0, 0, 0, 0.54)' }}>{t("Report.Receivable.PatientDetail.IdType")}</TableCell>
                        <TableCell className={classes.padding10px} style={{ color: 'rgba(0, 0, 0, 0.54)' }}>{t("Report.Receivable.PatientDetail.ExpDate")}</TableCell>
                        <TableCell className={classes.padding10px} style={{ color: 'rgba(0, 0, 0, 0.54)' }}>{t("Report.Receivable.PatientDetail.DOB")}</TableCell>
                        <TableCell className={classes.padding10px} style={{ color: 'rgba(0, 0, 0, 0.54)' }}>{t("Report.Receivable.PatientDetail.IDRawData")}</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {
                        this.state.selectedObject !== null ?
                          <TableRow>
                            <TableCell className={classes.padding10px} >{this.state.selectedObject.pfirst_name ? this.state.selectedObject.pfirst_name : ''}</TableCell>
                            <TableCell className={classes.padding10px}>{this.state.selectedObject.plast_name ? this.state.selectedObject.plast_name : ''}</TableCell>
                            <TableCell className={classes.padding10px}>{this.state.selectedObject.iscontactlessactivated === true ? 'Yes' : 'No'}</TableCell>
                            <TableCell className={classes.padding10px}>{this.state.selectedObject.pdrivers_license_no ? this.state.selectedObject.pdrivers_license_no : ''}</TableCell>
                            <TableCell className={classes.padding10px}><img style={{ borderRadius: '0%', width: '230px', height: '150px' }} alt="" src={(this.state.selectedObject.psignature_url !== null && this.state.selectedObject.psignature_url !== '') ? this.state.selectedObject.psignature_url : '/static/dashboard/global_assets/images/placeholders/no-image.svg'} /></TableCell>
                            <TableCell className={classes.padding10px}><Avatar style={{ borderRadius: '0%', width: '150px', height: '150px' }} alt="" src={(this.state.selectedObject.ppicture_url !== null && this.state.selectedObject.ppicture_url !== '') ? this.state.selectedObject.ppicture_url : '/static/dashboard/global_assets/images/placeholders/no-image.svg'} /></TableCell>
                            <TableCell className={classes.padding10px}>{this.state.selectedObject.relationship ? this.state.selectedObject.relationship.replace('_', ' ').replace('_', ' ') : ''}</TableCell>
                            <TableCell className={classes.padding10px}>{this.state.selectedObject.card_type ? this.state.selectedObject.card_type : ''}</TableCell>
                            <TableCell className={classes.padding10px}>{this.state.selectedObject.expdate ? this.state.selectedObject.expdate: ''}</TableCell>
                            <TableCell className={classes.padding10px}>{this.state.selectedObject.pdob ? this.state.selectedObject.pdob: ''}</TableCell>
                            <TableCell className={classes.padding10px}>{this.state.selectedObject.dlrawdata ?<textarea style={{resize:"vertical"}} cols={28} rows={8} readOnly>{this.state.selectedObject.dlrawdata}</textarea>  : ''}</TableCell>
                          </TableRow>
                          :
                          <TableRow>
                            <TableCell colSpan={5}>{t("Report.Receivable.NoDataFound")}</TableCell>
                          </TableRow>
                      }
                    </TableBody>
                  </Table>
                  {this.state.selectedObject && this.state.selectedObject.account_connections_id
                    && (this.state.selectedObject.account_connections_id === ConnectionType.QS1 ||
                      this.state.selectedObject.account_connections_id === ConnectionType.MCKESSONERX ||
                      this.state.selectedObject.account_connections_id === ConnectionType.EPIC ||
                      this.state.selectedObject.account_connections_id === ConnectionType.EPIC_WITH_MTLS ||
                      this.state.selectedObject.account_connections_id === ConnectionType.PIONEERRX ||
                      this.state.selectedObject.account_connections_id === ConnectionType.LIBERTY_SOFTWARE ||
                      this.state.selectedObject.account_connections_id === ConnectionType.DRX_INTEGRATION ||
                      this.state.selectedObject.account_connections_id === ConnectionType.MSCRIPTS) ?
                    <textarea
                      rows='4'
                      cols='90'
                      readOnly
                      placeholder="Retry Message"
                      value={this.state.retryMessg}
                    /> : ""}
                </DialogContent>
              </TabContainer>
              <TabContainer dir={theme.direction}>
                <DialogTitle id="form-dialog-title">{t("Report.Receivable.Temperature.TemperatureHistoryText")}</DialogTitle>
                <DialogContent>
                  <Grid container>
                    <Grid item xs={11} className="font-style">
                      &nbsp;
                    </Grid>
                    <Grid item xs={1} className="font-style">
                      <img alt="download" onClick={() => { this.exportTemperatureHistory() }} src={download} style={{ height: '32px', width: '32px', cursor: 'pointer' }} />
                    </Grid>
                  </Grid>
                  <Dashboard data={this.state && this.state.tempThresholds} startDate={this.state && this.state.selectedObject && this.state.selectedObject.stockeddate} endDate={this.state && this.state.selectedObject && this.state.selectedObject.pickupdate} margin="0%" convertTimeZone={this.convertToTimeZone} />
                </DialogContent>
              </TabContainer>
            </SwipeableViews>
            <DialogActions>
              {this.state.selectedObject && this.state.selectedObject.account_connections_id && this.state.selectedObject.account_connections_id === ConnectionType.QS1 ?
                <Button onClick={(e) => { this.handleRetry(e) }} color="primary" className={classes.primaryButton}>
                  {this.state.retryLoader ?
                    <CircularProgress color="inherit" size={20} /> :
                    t("Report.Receivable.PatientDetail.Retry")}
                </Button> : ""}
              {this.state.selectedObject && this.state.selectedObject.account_connections_id && this.state.selectedObject.account_connections_id === ConnectionType.MCKESSONERX ?
                <Button onClick={(e) => { this.handleMCKESSONERXRetry(e) }} color="primary" className={classes.primaryButton}>
                  {this.state.retryLoader ?
                    <CircularProgress color="inherit" size={20} /> :
                    t("Report.Receivable.PatientDetail.Retry")}
                </Button> : ""}
              {this.state.selectedObject && this.state.selectedObject.account_connections_id && this.state.selectedObject.account_connections_id === ConnectionType.EPIC ?
                <Button onClick={(e) => { this.handleEpicRetry(e) }} color="primary" className={classes.primaryButton}>
                  {this.state.retryLoader ?
                    <CircularProgress color="inherit" size={20} /> :
                    t("Report.Receivable.PatientDetail.Retry")}
                </Button> : ""}
              {this.state.selectedObject && this.state.selectedObject.account_connections_id && this.state.selectedObject.account_connections_id === ConnectionType.EPIC_WITH_MTLS ?
                <Button onClick={(e) => { this.handleEpicWithMTLSRetry(e) }} color="primary" className={classes.primaryButton}>
                  {this.state.retryLoader ?
                    <CircularProgress color="inherit" size={20} /> :
                    t("Report.Receivable.PatientDetail.Retry")}
                </Button> : ""}
              {this.state.selectedObject && this.state.selectedObject.account_connections_id && this.state.selectedObject.account_connections_id === ConnectionType.PIONEERRX ?
                <Button onClick={(e) => { this.handlePioneerRxRetry(e) }} color="primary" className={classes.primaryButton}>
                  {this.state.retryLoader ?
                    <CircularProgress color="inherit" size={20} /> :
                    t("Report.Receivable.PatientDetail.Retry")}
                </Button> : ""}
              {this.state.selectedObject && this.state.selectedObject.account_connections_id && this.state.selectedObject.account_connections_id === ConnectionType.LIBERTY_SOFTWARE ?
                <Button onClick={(e) => { this.handleLibertyRetry(e) }} color="primary" className={classes.primaryButton}>
                  {this.state.retryLoader ?
                    <CircularProgress color="inherit" size={20} /> :
                    t("Report.Receivable.PatientDetail.Retry")}
                </Button> : ""}
              {this.state.selectedObject && this.state.selectedObject.account_connections_id && this.state.selectedObject.account_connections_id === ConnectionType.DRX_INTEGRATION ?
                <Button onClick={(e) => { this.handleDRXRetry(e) }} color="primary" className={classes.primaryButton}>
                  {this.state.retryLoader ?
                    <CircularProgress color="inherit" size={20} /> :
                    t("Report.Receivable.PatientDetail.Retry")}
                </Button> : ""}
              {this.state.selectedObject && this.state.selectedObject.account_connections_id && this.state.selectedObject.account_connections_id === ConnectionType.MSCRIPTS ?
                <Button onClick={(e) => { this.handleMScriptsRetry(e) }} color="primary" className={classes.primaryButton}>
                  {this.state.retryLoader ?
                    <CircularProgress color="inherit" size={20} /> :
                    t("Report.Receivable.PatientDetail.Retry")}
                </Button> : ""}
              <Button onClick={(e) => { this.handlePrintReceipt(e) }} color="primary" className={classes.primaryButton}>
                {t("Report.Receivable.Temperature.PrintReceiptButton")}
              </Button>
              <Button onClick={(e) => { this.handlePUcodeClose(e) }} color="primary" className={classes.primaryButton}>
                {t("Report.Receivable.Temperature.CloseButton")}
              </Button>
            </DialogActions>
          </Dialog>
        </div>
        <div>
          <Dialog
            open={this.state.printDialogOpen || false}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullWidth={true}
            PaperProps={{
              style: { maxWidth: '700px', maxHeight: '100%' }
            }}
          >
            <DialogTitle id="alert-dialog-title">{t("Report.Receivable.Receipt.PickedUpReceipt")}</DialogTitle>
            <DialogContent>
              <Table aria-labelledby="tableTitle">
                {
                  this.state.selectedObject !== null ?
                    (<TableBody>
                      <TableRow className={classes.rowheight}>
                        <TableCell>{t("Report.Receivable.Receipt.PharmacyName")}:</TableCell>
                        <TableCell>{this.state.selectedObject.store}</TableCell>
                      </TableRow>
                      <TableRow className={classes.rowheight}>
                        <TableCell>{t("Report.Receivable.Receipt.KioskName")}:</TableCell>
                        <TableCell>{this.state.selectedObject.box}</TableCell>
                      </TableRow>
                      <TableRow className={classes.rowheight}>
                        <TableCell>{t("Report.Receivable.Receipt.Address")}:</TableCell>
                        <TableCell>{this.state && this.state.boxAddress}</TableCell>
                      </TableRow>
                      <TableRow className={classes.rowheight}>
                        <TableCell>{t("Report.Receivable.Receipt.PickupOrder")}:</TableCell>
                        <TableCell>{this.state.selectedObject.pucode}</TableCell>
                      </TableRow>
                      <TableRow className={classes.rowheight}>
                        <TableCell>{t("Report.Receivable.Receipt.PickupDate")}:</TableCell>
                        <TableCell>{this.state.selectedObject.pickupdate ? this.convertToTimeZone(this.state.selectedObject.pickupdate) : ''}</TableCell>
                      </TableRow>
                      <TableRow className={classes.rowheight}>
                        <TableCell>{t("Report.Receivable.Receipt.StockDate")}:</TableCell>
                        <TableCell>{this.state.selectedObject.stockeddate ? this.convertToTimeZone(this.state.selectedObject.stockeddate) : ''}</TableCell>
                      </TableRow>
                      <TableRow className={classes.rowheight}>
                        <TableCell>{t("Report.Receivable.Receipt.PatientName")}:</TableCell>
                        <TableCell>{this.state.selectedObject.username}</TableCell>
                      </TableRow>
                      <TableRow className={classes.rowheight}>
                        <TableCell style={{ borderBottom: 'none' }}><b>{t("Report.Receivable.Receipt.OrderDetail")}</b></TableCell>
                      </TableRow>
                      <TableRow className={classes.rowheight}>
                        <Table size="small" aria-label="a dense table">
                          {/* <TableHead> */}
                          <TableRow>
                            <TableCell>{t("Report.Receivable.Receipt.PrescriptionNumber")}</TableCell>
                            <TableCell align="right">{t("Report.Receivable.Receipt.RxNumber")}</TableCell>
                            <TableCell align="right">{t("Report.Receivable.Receipt.FillID")}</TableCell>
                          </TableRow>
                          {/* </TableHead> */}
                          <TableBody>
                            {/* {rows.map((row) => ( */}
                            <TableRow className={classes.rowheight}>
                              <TableCell component="th" scope="row">
                                {this.state.selectedObject.rxno}
                              </TableCell>
                              <TableCell align="right">{this.state.selectedObject.prescriptionnumber}</TableCell>
                              <TableCell align="right">{this.state.selectedObject.fillid}</TableCell>
                            </TableRow>
                            {/* ))} */}
                          </TableBody>
                        </Table>
                      </TableRow>
                      <TableRow className={classes.rowheight}>
                        <TableCell style={{ borderBottom: 'none' }}><b>{t("Report.Receivable.Receipt.Signature")}</b></TableCell>
                      </TableRow>
                      <TableRow className={classes.rowheight}>
                        <TableCell><Avatar style={{ border: '1px solid rgba(224, 224, 224, 1)', borderRadius: '0%', width: '100%', height: '150px' }} alt="" src={(this.state.selectedObject.psignature_url !== null && this.state.selectedObject.psignature_url !== '') ? this.state.selectedObject.psignature_url : '/static/dashboard/global_assets/images/placeholders/no-image.svg'} /></TableCell>
                      </TableRow>
                      <TableRow className={classes.rowheight}>
                        <TableCell style={{ borderBottom: 'none' }}><b>{t("Report.Receivable.Receipt.PickedUpBy")}</b></TableCell>
                      </TableRow>
                      <TableRow className={classes.rowheight}>
                        <TableCell>{t("Report.Receivable.Receipt.FirstName")}:</TableCell>
                        <TableCell>{this.state.selectedObject.pfirst_name}</TableCell>
                      </TableRow>
                      <TableRow className={classes.rowheight}>
                        <TableCell>{t('Report.Receivable.Receipt.LastName')}:</TableCell>
                        <TableCell>{this.state.selectedObject.plast_name}</TableCell>
                      </TableRow>
                      <TableRow className={classes.rowheight}>
                        <TableCell>{t("Report.Receivable.PatientDetail.Relationship")}:</TableCell>
                        <TableCell>{this.state.selectedObject.relationship}</TableCell>
                      </TableRow>
                      <TableRow className={classes.rowheight}>
                        <TableCell>{t("Report.Receivable.PatientDetail.IdType")}:</TableCell>
                        <TableCell>{this.state.selectedObject.card_type}</TableCell>
                      </TableRow>
                      <TableRow className={classes.rowheight}>
                        <TableCell>{t("Report.Receivable.PatientDetail.ExpDate")}:</TableCell>
                        <TableCell>{this.state.selectedObject.expdate}</TableCell>
                      </TableRow>
                      <TableRow className={classes.rowheight}>
                        <TableCell>{t("Report.Receivable.PatientDetail.DOB")}:</TableCell>
                        <TableCell>{this.state.selectedObject.pdob}</TableCell>
                      </TableRow>
                      <TableRow className={classes.rowheight}>
                        <TableCell>{t("Report.Receivable.Receipt.IDNo")}:</TableCell>
                        <TableCell>{this.state.selectedObject.pdrivers_license_no}</TableCell>
                      </TableRow>
                      <TableRow className={classes.rowheight}>
                        <TableCell><Avatar style={{ borderRadius: '0%', width: '60%', height: '150px' }} alt="" src={(this.state.selectedObject.ppicture_url !== null && this.state.selectedObject.ppicture_url !== '') ? this.state.selectedObject.ppicture_url : '/static/dashboard/global_assets/images/placeholders/no-image.svg'} /></TableCell>
                      </TableRow>
                    </TableBody>)
                    :
                    (<TableBody>
                      <TableRow>
                        <TableCell colSpan={5}>{t("Report.Receivable.NoDataFound")}</TableCell>
                      </TableRow>
                    </TableBody>)
                }
              </Table>
            </DialogContent>
          </Dialog>
        </div>
                <ReportToolbar>
                  <Tooltip key="single-edit" title={t("Report.Receivable.ExportCSVTooltip")}>
                    <IconButton
                      style={{ marginRight: '0' }}
                      aria-label="ExportCSV"
                      onClick={() => { this.exportCSV() }}
                      disabled={this.state.isButtonDisabled}>
                      <img alt="download" src={download} style={{ height: '32px', width: '32px', cursor: 'pointer' }} />
                    </IconButton>
                  </Tooltip>
                </ReportToolbar>

                <div className={classes.tableWrapper}>
                    <ILocalAGGrid
            columnDefs={[
              { field: 'firstname', headerName: t("Report.Receivable.FirstName"), colId: 'firstname' },
              { field: 'lastname', headerName: t("Report.Receivable.LastName"), colId: 'lastname' },
              { field: 'store', headerName: t("Report.Receivable.Account"), colId: 'store' },
              { field: 'box', headerName: t("Report.Receivable.Location"), colId: 'box' },
              { field: 'amount_due', headerName: t("Report.Receivable.AmountDue"), colId: 'amount_due', valueFormatter: (p) => p.value != null ? '$' + parseFloat(p.value).toFixed(2) : '$0.00' },
              { field: 'paid_amount', headerName: t("Report.Receivable.Paid"), colId: 'paid_amount', valueFormatter: (p) => p.value != null ? '$' + parseFloat(p.value).toFixed(2) : '$0.00' },
              { field: 'balance_due', headerName: t("Report.Receivable.BalanceDue"), colId: 'balance_due', valueFormatter: (p) => p.value != null ? '$' + parseFloat(p.value).toFixed(2) : '$0.00' },
              { field: 'entry_type', headerName: t("Report.Receivable.EntryType"), colId: 'entryType' },
              withDateColumnFilter({ field: 'payment_date', headerName: t("Report.Receivable.PaymentDate"), colId: 'payDate', valueFormatter: (p) => p.value ? this.convertToTimeZone(p.value) : '' }),
              { field: 'payment_type', headerName: t("Report.Receivable.PaymentType"), colId: 'payType' },
              { field: 'rxno', headerName: t("Report.Receivable.RxHash"), colId: 'rxno' },
              { field: 'prescriptionnumber', headerName: t("Report.Receivable.PrescriptionID"), colId: 'prescriptionnumber' },
              withClickableCell(
                { field: 'pucode', headerName: t("Report.Receivable.PUCode"), colId: 'pucode' },
                (e, row) => this.handlePUcodeClick(e, row)
              ),
              { field: 'stockeddate', headerName: t("Report.Receivable.StockDate"), colId: 'stockeddate', valueFormatter: (p) => p.value ? this.convertToTimeZone(p.value) : '' },
              { field: 'pickupdate', headerName: t("Report.Receivable.PickupDate"), colId: 'pickupdate', valueFormatter: (p) => p.value ? this.convertToTimeZone(p.value) : '' },
            ]}
            defaultColDef={getDefaultColDef()}
            rowModelType="serverSide"
            cacheBlockSize={(TransactionFilterObj.pageSize || 25)}
            paginationPageSize={(TransactionFilterObj.pageSize || 25)}
            paginationPageSizeSelector={[10, 20, 25]}
            rowHeight={40}
            getRowId={(params) =>
              (params.data && (params.data.prescription_txn_id || params.data.id || params.data.pmid || params.data.uuid)) ||
              String(params.data && JSON.stringify(params.data).slice(0,40))
            }
            onGridReady={this.onGridReady}
            onPaginationChanged={this.onPaginationChanged}
          />
          </div>
      </Paper>
    );
  }
}

EnhancedTable.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles, { withTheme: true })(withTranslation()(EnhancedTable));



// WEBPACK FOOTER //
// ./src/components/reports/ipay_receivables/index.js